function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2493 28C14.1809 28 15.7477 26.4332 15.7477 24.5H8.75097C8.75097 26.4332 10.3178 28 12.2493 28ZM24.0284 19.8127C22.9719 18.6774 20.9949 16.9695 20.9949 11.375C20.9949 7.12578 18.0156 3.72422 13.9982 2.88969V1.75C13.9982 0.783672 13.2151 0 12.2493 0C11.2835 0 10.5004 0.783672 10.5004 1.75V2.88969C6.48308 3.72422 3.50371 7.12578 3.50371 11.375C3.50371 16.9695 1.52676 18.6774 0.470195 19.8127C0.14207 20.1655 -0.00339847 20.5871 -0.000664094 21C0.00535152 21.8969 0.709179 22.75 1.7548 22.75H22.7438C23.7895 22.75 24.4938 21.8969 24.4993 21C24.502 20.5871 24.3566 20.1649 24.0284 19.8127Z",
  fill: "#EB6012"
});
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.9d306334a47363a68899c4144e39e372.svg";
export { ForwardRef as ReactComponent };